export const GET_EMPLOYEES = {
  GET_EMPLOYEES_REQUEST: 'GET_EMPLOYEES_REQUEST',
  GET_EMPLOYEES_SUCCESS: 'GET_EMPLOYEES_SUCCESS',
  GET_EMPLOYEES_FAILED: 'GET_EMPLOYEES_FAILED',
};

export const GET_EMPLOYEE_SUMMARY = {
  GET_EMPLOYEE_SUMMARY_REQUEST: 'GET_EMPLOYEE_SUMMARY_REQUEST',
  GET_EMPLOYEE_SUMMARY_SUCCESS: 'GET_EMPLOYEE_SUMMARY_SUCCESS',
  GET_EMPLOYEE_SUMMARY_FAILED: 'GET_EMPLOYEE_SUMMARY_FAILED',
};
